<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Pause Game</span>
  <ng-container dialog-content>
    <div>
      <p>Pausing a game will prevent any new draws from being created until after the unpause date.</p>
    </div>
    <form [formGroup]="pauseGameForm">
      <mat-form-field appearance="outline" class="full-width margin-top-med">
        <mat-label>When should the game be paused?</mat-label>
        <mat-select formControlName="pauseGameWhen" data-testid="pause-game-when-select">
          <mat-option value="{{PAUSE_AFTER_DRAW}}" data-testid="pause-after-draw-option">After current draw</mat-option>
          <mat-option value="{{PAUSE_AFTER_WINNER}}" data-testid="pause-after-winner-option">After next winner</mat-option>
        </mat-select>
        <mat-hint>
          @if(pauseGameWhenOption.value === PAUSE_AFTER_DRAW) {
            The game will be paused after the current draw concludes.
          }
          @if(pauseGameWhenOption.value === PAUSE_AFTER_WINNER) {
            The game will be paused the next time a player wins a draw.
          }
        </mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-med">
        <mat-label>Unpause Date</mat-label>
        <input
          matInput
          formControlName="unpauseDate"
          class="margin-top-med full-width"
          type="datetime-local"
          id="unpause-date"
          data-testid="unpause-date-input"
          name="unpause date"/>
        <mat-hint>Use your local time zone, not the game's time zone.</mat-hint>
      </mat-form-field>

      <mat-label class="margin-top-med">Cancel All Autoplays</mat-label>
      <mat-checkbox formControlName="cancelAutoplays"></mat-checkbox>

      @if(cancelAutoplaysOption.value === true) {
        <div class="red-text">
          <p>
            All active autoplays will be canceled when the game pauses. <strong>This cannot be undone.</strong>
          </p>
        </div>
      }

    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary"
            data-testid="pause-game-submit-button"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
